module.exports = __webpack_public_path__ + "img/right-more-3.ea09bac4.png";